class AddToWishlist extends HTMLElement {
    constructor() {
        super();
        this.initAddToWishlist();
        this.setupVariantChangeListener();
        this.onclick = this.handleClick.bind(this);
    }

    setupVariantChangeListener() {
        // Escuchamos cambios en la selección de variantes
        document.addEventListener('variantChange', (event) => {
            if (event.detail && event.detail.variantId) {
                this.setAttribute('variant-id', event.detail.variantId);
            }
        });
        
        // Observamos cambios en el campo oculto
        const variantIdInput = document.querySelector('.product-variant-id');
        if (variantIdInput) {
            const observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                        const newVariantId = variantIdInput.value;
                        this.setAttribute('variant-id', newVariantId);
                    }
                }
            });
            
            observer.observe(variantIdInput, { attributes: true });
        }
    }

    getUpdatedAttributes() {
        this.wishlistText = this.getAttribute("text");
        this.productId = this.getAttribute("product-id");
        this.productUrl = this.getAttribute("data-url");
        this.variantId = this.getAttribute("variant-id");
    }

    handleClick() {
        this.getUpdatedAttributes();
        
        console.log("Clic en Add to Wishlist:");
        console.log("wishlistText:", this.wishlistText);
        console.log("productId:", this.productId);
        console.log("productUrl:", this.productUrl);
        console.log("variantId:", this.variantId);
        
        window.addEventListener(`added-to-wishlist`, async (event) => {
            await new Promise(r => setTimeout(r, 1000))
            this.initAddToWishlist();
            displayElementOnSideBar(`custom-wishlist`, getCartHeader(`wishlist`), `right`, false);
        });
        
        window.dispatchEvent(new CustomEvent("product-added-to-wishlist", {
            detail: {
                productId: this.productId,
                productUrl: this.productUrl,
                variantId: this.variantId
            }
        }));
    }

    initAddToWishlist() {
        this.getUpdatedAttributes();
        this.innerHTML = `<div>${this.wishlistText}</div>`;
        this.style.fontSize = "14px";
        this.style.color = "#1F1F1F";
    }
}

customElements.define('add-to-wishlist', AddToWishlist);